/**
  we use the presence of display hours to know whether the location is closed
  for a particular fulfillment method because of later hours disabled (display hours
  will still be populated) or if it's closed for the method because they are simply not
  accepting orders of that fulfillment method type
*/
export const shouldDisplayNoAsapAvailableOrderInfo = (
  isAcceptingOrdersForFulfillmentMethod,
  isAcceptingLaterOrders,
  displayHoursForFulfillmentMethod
) => {
  return (
    !isAcceptingOrdersForFulfillmentMethod &&
    !isAcceptingLaterOrders &&
    (displayHoursForFulfillmentMethod.today.hours.length > 0 ||
      displayHoursForFulfillmentMethod.weekday_hours.length > 0)
  );
};
